import { render, staticRenderFns } from "./topicTwo.vue?vue&type=template&id=92b551e4&scoped=true&"
import script from "./topicTwo.vue?vue&type=script&lang=js&"
export * from "./topicTwo.vue?vue&type=script&lang=js&"
import style0 from "./topicTwo.vue?vue&type=style&index=0&id=92b551e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b551e4",
  null
  
)

export default component.exports